import { useAuth } from "../../context/AuthContext";
import AdminLayout from "./components/Admin";
import WorkerLayout from "./components/Worker";

const Layout = () => {
  const { user } = useAuth();

  const isAdmin =
    user?.roles?.includes("admin") || user?.roles?.includes("superuser");

  if (isAdmin) {
    return <AdminLayout />;
  }

  return <WorkerLayout />;
};

export default Layout;
